export default class PayGateTransaction {
  year: number;
  month: number;
  bruttoAmount: number;
  nettoAmount: number;
  commissionFee: number;
}
